// @ts-check
import { Component } from '@verndale/core';
import { rovingIndex } from '@verndale/roving-ux';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $info: this.el.querySelector('.footer__info'),
      $socialMobile: this.el.querySelector('.footer__social--mobile'),
      $groupToggleButtons: this.el.querySelectorAll(
        '.footer__link-group-button'
      ),
      $linkGroups: this.el.querySelector('.footer__link-groups')
    };

    this.moveDOM();
    this.setRovings();
  }

  addListeners() {
    this.dom.$groupToggleButtons.forEach((button) =>
      button.addEventListener('click', this.handleGroupToggle)
    );
  }

  setRovings() {
    rovingIndex({
      element: this.dom.$linkGroups,
      target: '.footer__link-group-button'
    });
  }

  moveDOM() {
    if (this.dom.$info && this.dom.$socialMobile) {
      const parent = this.dom.$info.parentElement;

      parent.insertBefore(this.dom.$socialMobile, this.dom.$info);
    }
  }

  handleGroupToggle(e) {
    const isExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
    e.currentTarget.setAttribute('aria-expanded', !isExpanded);
    e.currentTarget.closest('.footer__link-group').dataset.expanded =
      !isExpanded;
  }
}

export default Module;
